import { handleErrors } from "../util/api-utils";

/**
 * Saves the updated additional information section of the agency profile.
 * @param {string} logDetails The updated agency profile.
 * @param {function} successCallback The success callback function.
 * @param {function} finallyCallback The finally callback function.
 */
export function logDetails(logDetails, successCallback, finallyCallback) {
    fetch("api/LoggerConfiguration/LogDetails", {
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(logDetails)
    })
        .then(handleErrors)
        .then(successCallback)
        .catch(console.error)
        .finally(finallyCallback);
};

export function logError(errorDetails, successCallback, finallyCallback) {
    fetch("api/LoggerConfiguration/LogError", {
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(errorDetails)
    })
        .then(handleErrors)
        .then(successCallback)
        .catch(console.error)
        .finally(finallyCallback);
}

export function getOperationId(successCallback) {
    return fetch("api/LoggerConfiguration/OperationId", {
        method: "get",
        headers: {
            "Accept": "application/json",
        },
    })
        .then(successCallback)
        .catch(console.error);
}
